// extracted by mini-css-extract-plugin
export var drawerPaper = "_1z-0";
export var itemImage = "_1z-1";